import styled, {css} from 'styled-components';

import breakpoints from '~constants/breakpoints';

export const Wrapper = styled.div`
    font-size: 14px;
    position: relative;
    width: 165px;
    height: 34px;

    ${breakpoints.abovePhone} {
        width: 210px;
    }
`;

export const Select = styled.div`
    width: 100%;
    height: 34px;
    border-radius: 12px;
    padding: 6px 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.03) url('/assets/images/icons/ui/chevron-down.svg')
        no-repeat right 12px center;
`;

export const DropDown = styled.div<{open: boolean}>`
    top: calc(100% + 2px);
    width: 100%;
    padding: 8px;
    position: absolute;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 17px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    z-index: 1;
    transition: all 0.3s ease;
    transform: translateY(-80%);
    visibility: hidden;
    pointer-events: none;
    opacity: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;

    ${({open}) =>
        open &&
        css`
            transform: translateY(0);
            visibility: visible;
            pointer-events: auto;
            opacity: 1;
        `}
`;

export const Option = styled.div<{selected: boolean}>`
    width: 100%;
    height: 34px;
    border-radius: 8px;
    padding: 6px 12px;
    display: flex;
    align-items: center;
    cursor: pointer;

    ${({selected}) =>
        selected &&
        css`
            background: rgba(0, 0, 0, 0.03);
        `}
    &:hover {
        background: rgba(0, 0, 0, 0.03);
    }
`;
